module.exports = __webpack_public_path__ + "static/img/y56.9754f78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y56.jpg
// module id = EbGE
// module chunks = 1